<section class="vc_section day_out_mainbox bottom_txt">
    <div class="vc_row wpb_row vc_row-fluid">
        <div class="wpb_column vc_column_container vc_col-sm-12">
            <div class="vc_column-inner">
                <div class="wpb_wrapper">
                    <div class="vc_empty_space" style="height: 35px;"><span class="vc_empty_space_inner"></span></div>
                </div>
            </div>
        </div>
    </div>
    <div class="vc_row wpb_row vc_row-fluid accomodation_txt">
        <div class="wpb_column vc_column_container vc_col-sm-12">
            <div class="vc_column-inner">
                <div class="wpb_wrapper">
                    <div class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_sep_color_grey vc_separator-has-text">
                        <span class="vc_sep_holder vc_sep_holder_l"><span class="vc_sep_line"></span></span>
                        <h4>OFFERS</h4>
                        <span class="vc_sep_holder vc_sep_holder_r"><span class="vc_sep_line"></span></span>
                    </div>
                    <div class="wpb_text_column wpb_content_element">
                        <div class="wpb_wrapper">
                            <p>Book 4 days prior check in to avail 10% discount on weekdays ( Monday – Thursday ).</p>
                        </div>
                    </div>
                    <div class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_sep_color_grey vc_separator-has-text">
                        <span class="vc_sep_holder vc_sep_holder_l"><span class="vc_sep_line"></span></span>
                        <h4>Cancellation - Postponement - Refund </h4>
                        <span class="vc_sep_holder vc_sep_holder_r"><span class="vc_sep_line"></span></span>
                    </div>
                    <div class="wpb_text_column wpb_content_element">
                        <div class="wpb_wrapper">
                            <p class="ltr">
                              If the cancellation is done 10 days prior to check-in date, 100% shall be refunded.
                            </p>
                            <p class="ltr">
                              If the cancellation is done 48 hours prior to the check-in date,25% of the total amount shall be deducted.
                            </p>
                            <p class="ltr">
                              If the cancellation is done less than 48hours prior to the check-in date, the advance amount shall not be refunded.
                            </p>
                            <p class="ltr">
                              Cancellation charges will be deducted from the total amount.
                            </p>
                            <p class="ltr">
                              No refund is allowed for not utilizing or not cancelling the booking.
                            </p>
                            <p class="ltr">
                              Once the booking is postponed there shall be no refund.
                            </p>
                            <p class="ltr">
                                Refunds for canceled booking will be automatically credited to the guest account within 10 bank working days from the date of check-in.
                            </p>
                            <p class="ltr">
                                Postponement is done subject to the availability and can be processed only once.
                            </p>
                            <p class="ltr">
                                Preponement /postponement please contact our customer care.
                            </p>
                            <!-- <p dir="ltr">Dear guests,</p>
                            <p dir="ltr">Considering covid-19, we at Mangomist resorts have introduced below strict safeguard operations to protect our guests and employees</p>
                            <p dir="ltr"><strong>Limited bookings:</strong> Bookings are limited to control the number of guests.</p>
                            <p><strong>Going online :</strong> All payments, room service order, check in and check out are done online, please carry your mobile phones and chargers along.</p>
                            <p>
                                <strong>Hygiene + Restaurants :</strong> We are ISO 22000 certified, limited to 20 % occupancy, food served is UV and heat treated, we are introducing an online menu and encourage online
                                ordering only, all cutlery and crockery are washed and dried using an automated german imported machine at 90°C.
                            </p>
                            <p>
                                <strong>Hygiene + Cottages :</strong>&nbsp; All linen is washed with in-house industrial no-human-touch machines using 80°C hot water. Rooms are UV treated before check in. More frequent
                                cleaning and disinfecting of high touch areas&nbsp; in our public spaces.
                            </p>
                            <p>
                                <strong>Hygiene + sports :</strong> &nbsp;All sports and adventure equipment are sanitised and UV treated before every use. Enhanced social distancing and sanitisation measures introduced in
                                public spaces.
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="vc_row wpb_row vc_row-fluid accomodation_txt">
        <div class="wpb_column vc_column_container vc_col-sm-12">
            <div class="vc_column-inner">
                <div class="wpb_wrapper">
                    <div class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_sep_color_grey vc_separator-has-text">
                        <span class="vc_sep_holder vc_sep_holder_l"><span class="vc_sep_line"></span></span>
                        <h4>Prior booking information</h4>
                        <span class="vc_sep_holder vc_sep_holder_r"><span class="vc_sep_line"></span></span>
                    </div>
                    <div class="wpb_text_column wpb_content_element">
                        <div class="wpb_wrapper">
                            <ol class="content">
                                <li class="style94">Prior Reservation / Booking Mandatory.</li>
                                <li class="style94">
                                    Guests should produce valid Indian Govt. ID during Check-in ( Aadhar / PAN / Driving license / Voters ID / Passport ) . The person booking &amp; staying should be above 21 years of age.
                                    People below 12 years /old / infants / sick people are not recommended / allowed to camp. Declaration form to be signed prior to check-in. Please read&nbsp;
                                    <a
                                        href="http://bookings.mangomist.com/terms-and-conditions/"
                                        target="_blank"
                                        rel="noreferrer"
                                        data-saferedirecturl="https://www.google.com/url?q=http://bookings.mangomist.com/terms-and-conditions/&amp;source=gmail&amp;ust=1556260032148000&amp;usg=AFQjCNHlrpZ1TNKmb0vq-Y9KVy3RvqCADQ"
                                    >
                                        terms and conditions
                                    </a>
                                    &nbsp;thoroughly.
                                </li>
                                <li class="style94">All prices mentioned above exclude applicable taxes.</li>
                                <li class="style94">All kinds of outside beverages &amp; eatables are strictly prohibited.</li>
                                <li class="style94">Standard Facilities include: Swimming Pools / Mist Dance / Indoor &amp; Out Door Games.</li>
                                <li class="style94">Swimming Costume Nylon / Polyester wear Mandatory. (Towels to be carried)</li>
                                <li class="style94">MC/PA system &amp; Team Building Activities can be provided on request at additional cost.</li>
                                <li class="style94">Drink Responsibly, do not drink and drive, We serve liquor only to people above 21 years.</li>
                                <li class="style94">
                                    Adventures activities are coupon based :Archery, Bottle/Mango Shooting, Commando Net, Rock Climbing, Quake walk, Trampoline, Burma Loop, Russian Ladder, Bamboo Burma, Burma Bridge, Pyramid Walk, Monkey Crawling, Skywalk, Slack line, Rope walk (Requires 1 coupons per activity per person). Zip line, Water Roller, Bull Ride (Requires 2 coupons per activity per person). Kayaking Water Zorbing, Land Zorbing & Fish Spa (Requires 3 coupons per activity per person). Paintball ( 30 bullets ) (@Rs350/person) . Declaration form to be signed prior participation 
                                    <a href="#" target="_blank">terms and conditions</a> thoroughly.
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .day_out_mainbox.bottom_txt {
		margin: 0 5px 0 0;
		width: auto !important;
	}

	.vc_section {
		padding-left: 15px;
		padding-right: 15px;
		margin-left: -15px;
		margin-right: -15px;
	}
	.day_out_mainbox {
		-moz-border-bottom-colors: none;
		-moz-border-left-colors: none;
		-moz-border-right-colors: none;
		-moz-border-top-colors: none;
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		box-shadow: 8px 8px 8px #888888;
		margin: 0 auto;
		position: relative;
		width: 48% !important;
	}

	.vc_sep_pos_align_center {
		margin-left: auto;
		margin-right: auto;
	}
	
	.vc_sep_width_100 {
		width: 100%;
	}

	.vc_separator {
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-flex-wrap: nowrap;
		-ms-flex-wrap: nowrap;
		flex-wrap: nowrap;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.vc_separator .vc_sep_holder {
		height: 1px;
		position: relative;
		-webkit-box-flex: 1;
		-webkit-flex: 1 1 auto;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		min-width: 10%;
	}

	.vc_separator.vc_separator_align_center h4 {
		padding: 0 0.8em;
	}

	.vc_separator h4 {
		line-height: 1em;
		font-size: 100%;
		margin: 0;
		word-wrap: break-word;
		-webkit-box-flex: 0;
		-webkit-flex: 0 1 auto;
		-ms-flex: 0 1 auto;
		flex: 0 1 auto;
	}

	.vc_separator.vc_sep_color_grey .vc_sep_line {
		border-color: #EBEBEB;
	}

	.vc_separator .vc_sep_holder .vc_sep_line {
		height: 1px;
		border-top: 1px solid #EBEBEB;
		display: block;
		position: relative;
		top: 1px;
		width: 100%;
	}

    strong {
        font-weight: bold;
    }

    .wpb_wrapper {
        overflow: hidden;
        margin-bottom: 24px;
    }

    .content li {
        color: #444;
        font-size: 1.125rem;
        line-height: 2rem;
    }

    .vc_separator {
        margin-bottom: 35px;
    }

</style>